/* eslint-disable no-unused-expressions */
export const getTaxAmount = (item, isAdjustedField) => {
  let taxAmount = 0;
  let tax = 0;
  item?.tax?.forEach((itemTax) => {
    let priceAmount = parseFloat(item.quantity) * parseFloat(isAdjustedField ? (item?.price_adjust || item.price) : item.price);
    if (item?.amount) {
      priceAmount = item?.amount;
    }
    if (priceAmount < 0) return;
    if (parseFloat(itemTax?.threshold)?.toString()==='NaN' || Number(itemTax?.threshold) === 0) {
      tax = parseFloat(priceAmount) * parseFloat(itemTax.tax_rate/100);
    } else if (parseFloat(priceAmount) * parseFloat(itemTax.tax_rate/100) < parseFloat(itemTax?.threshold)) {
      tax = parseFloat(priceAmount) * parseFloat(itemTax.tax_rate/100);
    } else {
      tax = parseFloat(itemTax?.threshold);
    }
    const perTax = tax;
    taxAmount = parseFloat(taxAmount) + parseFloat(perTax);
  });
  return parseFloat(taxAmount).toFixed(2);
};

export const getItemAmount = (item, isAdjustedField) => {
  let price = parseFloat(item.quantity) * parseFloat(isAdjustedField ? (item?.price_adjust || item.price) : item.price);
  if (item?.amount) {
    price = item?.amount;
  }
  const amount = parseFloat(price);
  return parseFloat(amount).toFixed(2);
};

export const getallTaxAmount = (itemsList, isAdjustedField) => {
  let taxAmount = 0;
  if (itemsList) {
    itemsList.forEach((item) => {
      taxAmount = parseFloat(taxAmount) + parseFloat(getTaxAmount(item, isAdjustedField));
    });
  }
  return parseFloat(taxAmount).toFixed(2);
};

export const getallPrices = (itemsList, isAdjustedField) => {
  let priceAmount = 0;
  if (itemsList) {
    itemsList.forEach((item) => {
      let price = (parseFloat(item.quantity) * parseFloat(isAdjustedField ? (item?.price_adjust || item.price): item.price)).toFixed(2);
      if (item?.amount) {
        price = item?.amount;
      }
      if (price < 0) return;
      priceAmount = parseFloat(priceAmount) + parseFloat(price);
    });
  }
  return parseFloat(priceAmount).toFixed(2);
};


export const getTotalAmount = (itemsList, isAdjustedField) => {
  let amount = 0;
  if (itemsList) {
    amount = parseFloat(getallPrices(itemsList, isAdjustedField))
    + parseFloat(getallTaxAmount(itemsList, isAdjustedField)) + parseFloat(getallFeeAmount(itemsList, isAdjustedField));
  }
  return parseFloat(amount).toFixed(2);
};

export const getTotalPaymentAmount = (payments) => {
  let amount = 0;
  if (payments) {
    payments.forEach((payment) => {
      amount += parseFloat(payment?.amount);
    });
  }
  return parseFloat(amount).toFixed(2);
};

export const getFeeAmount = (item) => {
  let fee = 0;
  if (item?.fee) {
    item.fee.forEach((itemFee) => {
      fee += parseFloat(itemFee.tax_rate);
    });
  }
  return parseFloat(fee).toFixed(2);
};

export const getallFeeAmount = (itemsList) => {
  let feeAmount = 0;
  if (itemsList) {
    itemsList.forEach((item) => {
      feeAmount += parseFloat(getFeeAmount(item));
    });
  }
  return parseFloat(feeAmount).toFixed(2);
};
